<script setup lang="ts">
import { useToasts } from '../toasts'

const toasts = useToasts()
</script>

<template>
  <div class="toast-stack" aria-live="polite" aria-atomic="false">
    <button
      v-for="toast in toasts.items"
      :key="toast.id"
      type="button"
      class="toast"
      :class="`toast--${toast.tone}`"
      @click="toasts.dismiss(toast.id)"
    >
      <span class="toast__dot"></span>
      <span>{{ toast.text }}</span>
      <span class="toast__close" aria-hidden="true">×</span>
    </button>
  </div>
</template>
